// extracted by mini-css-extract-plugin
export default {"filter-relation-box-block-root":"FilterRelationBoxBlock_filter-relation-box-block-root__WtGKx","block":"FilterRelationBoxBlock_block__pZkUh"};